import React, { useState, useRef, useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { COLUMNS } from '../data/mockOrders';
import { cn } from '../lib/utils';

const { FiChevronDown } = FiIcons;

const StatusDropdown = ({ selectedStatus, onStatusChange, orderCounts }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleStatusSelect = (status) => {
    onStatusChange(status);
    setIsOpen(false);
  };

  const currentColumn = COLUMNS[selectedStatus];
  const isDone = selectedStatus === 'Completed' || selectedStatus === 'Archived';

  return (
    <div className="relative z-40" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "w-full flex items-center justify-between px-4 py-3 rounded-md transition-colors shadow-lg",
          isDone ? "bg-zinc-800" : "bg-yellow-400"
        )}
      >
        <div className="flex items-center gap-3">
          <h3 className={cn(
            "font-black uppercase tracking-wide text-base",
            isDone ? "text-zinc-400" : "text-black"
          )}>
            {currentColumn?.title || selectedStatus}
          </h3>
          <span className={cn(
            "px-2 py-0.5 rounded text-sm font-black",
            isDone ? "bg-black text-zinc-500" : "bg-black text-yellow-400"
          )}>
            ({orderCounts[selectedStatus] || 0})
          </span>
        </div>
        <SafeIcon 
          icon={FiChevronDown} 
          className={cn(
            "transition-transform",
            isDone ? "text-zinc-400" : "text-black",
            isOpen && "rotate-180"
          )} 
          size={20} 
        />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-zinc-900 border border-zinc-700 rounded-lg shadow-2xl overflow-hidden">
          {Object.entries(COLUMNS).map(([statusKey, statusData]) => {
            const isSelected = statusKey === selectedStatus;
            const isStatusDone = statusKey === 'Completed' || statusKey === 'Archived';
            const count = orderCounts[statusKey] || 0;

            return (
              <button
                key={statusKey}
                onClick={() => handleStatusSelect(statusKey)}
                className={cn(
                  "w-full flex items-center justify-between px-4 py-3 transition-colors border-b border-zinc-800 last:border-b-0",
                  isSelected ? "bg-yellow-400 text-black" : "hover:bg-zinc-800 text-white"
                )}
              >
                <span className="font-bold uppercase tracking-wide">
                  {statusData.title}
                </span>
                <span className={cn(
                  "px-2 py-0.5 rounded text-sm font-black",
                  isSelected ? "bg-black text-yellow-400" : isStatusDone ? "bg-zinc-800 text-zinc-500" : "bg-zinc-700 text-zinc-300"
                )}>
                  ({count})
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StatusDropdown;